import { useTranslation } from 'react-i18next'
import styles from './Form1NKTable.module.scss'

const YEARS = ['y1', 'y2', 'y3', 'y4', 'y5']

const Form1NKTable = ({ data }) => {
  const { t } = useTranslation('common')

  const FORM_GROUPS = [
    { key: 'full_time', label: t('reports.form_full_time') },
    { key: 'evening', label: t('reports.form_evening') },
    { key: 'external', label: t('reports.form_external') },
  ]

  if (!data || !Array.isArray(data.directions)) {
    return <div className="unv-empty">{t('reports.no_data')}</div>
  }

  const totals = data.totals || {}

  return (
    <div className={styles.wrap}>
      <table className={`unv-table ${styles.table}`}>
        <thead>
          <tr>
            <th rowSpan={2} className={styles.stickyCol}>{t('reports.col_code')}</th>
            <th rowSpan={2} className={styles.stickyCol}>{t('reports.col_direction')}</th>
            {FORM_GROUPS.map((g) => (
              <th key={g.key} colSpan={YEARS.length + 1} className={styles.groupHead}>
                {g.label}
              </th>
            ))}
            <th rowSpan={2} className={styles.totalCol}>{t('reports.col_total')}</th>
          </tr>
          <tr>
            {FORM_GROUPS.map((g) => (
              <Cells key={g.key} prefix={g.key} />
            ))}
          </tr>
        </thead>
        <tbody>
          {data.directions.length === 0 ? (
            <tr>
              <td colSpan={2 + FORM_GROUPS.length * (YEARS.length + 1) + 1}>
                <div className="unv-empty">{t('reports.no_data')}</div>
              </td>
            </tr>
          ) : (
            data.directions.map((d) => {
              const lineTotal = FORM_GROUPS.reduce(
                (acc, g) => acc + (d.by_form_year?.[g.key]?.total || 0),
                0,
              )
              return (
                <tr key={`${d.code}-${d.name}`}>
                  <td className={styles.stickyCol}>{d.code || '—'}</td>
                  <td className={styles.stickyCol}>{d.name}</td>
                  {FORM_GROUPS.map((g) => {
                    const block = d.by_form_year?.[g.key] || {}
                    return (
                      <CellsBody key={g.key} block={block} />
                    )
                  })}
                  <td className={styles.totalCol}><strong>{lineTotal}</strong></td>
                </tr>
              )
            })
          )}
        </tbody>
        <tfoot>
          <tr className={styles.totalRow}>
            <td colSpan={2} className={styles.stickyCol}><strong>{t('reports.row_grand_total')}</strong></td>
            {FORM_GROUPS.map((g) => {
              const block = totals[g.key] || {}
              return <CellsBody key={g.key} block={block} bold />
            })}
            <td className={styles.totalCol}><strong>{totals.grand || 0}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

const Cells = () => (
  <>
    {YEARS.map((y) => (
      <th key={y}>{y.replace('y', 'К')}</th>
    ))}
    <th>Σ</th>
  </>
)

const CellsBody = ({ block, bold = false }) => (
  <>
    {YEARS.map((y) => (
      <td key={y}>{bold ? <strong>{block?.[y] || 0}</strong> : (block?.[y] || 0)}</td>
    ))}
    <td>{bold ? <strong>{block?.total || 0}</strong> : (block?.total || 0)}</td>
  </>
)

export default Form1NKTable
